import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBatteryError: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"battery-error, power"} maskId="square-filled-radius-0-stroke-1-IconBatteryError"><path fillRule="evenodd" clipRule="evenodd" d="M1 5V19H20V16H23V8H20V5H1ZM20 9V15H22V9H20ZM7.04289 9.75L7.75 9.04289L10 11.2929L12.25 9.04289L12.9571 9.75L10.7071 12L12.9571 14.25L12.25 14.9571L10 12.7071L7.75 14.9571L7.04289 14.25L9.29289 12L7.04289 9.75Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBatteryError;
